import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'react-feather';

/**
 * Compact pagination for the v3 admin tables.
 *
 * Renders: "Showing X–Y of N" on the left, page buttons on the right.
 * Page button window is fixed at 5 — current page is centered when possible.
 */
const Pagination = ({ page, pageCount, total, pageSize, onPageChange }) => {
    const { t } = useTranslation();
    if (!total) return null;

    const first = (page - 1) * pageSize + 1;
    const last = Math.min(page * pageSize, total);

    const windowSize = 5;
    let start = Math.max(1, page - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;
    if (end > pageCount) {
        end = pageCount;
        start = Math.max(1, end - windowSize + 1);
    }
    const buttons = [];
    for (let i = start; i <= end; i++) buttons.push(i);

    return (
        <div className="v3-sadmin-pagination">
            <span>{t('Showing {{first}}–{{last}} of {{total}}', { first, last, total })}</span>
            <div className="v3-sadmin-pagination-controls">
                <button
                    type="button"
                    className="v3-sadmin-page-btn"
                    onClick={() => onPageChange(page - 1)}
                    disabled={page <= 1}
                    aria-label={t('Previous page')}
                >
                    <ChevronLeft size={14} />
                </button>
                {buttons.map((b) => (
                    <button
                        type="button"
                        key={b}
                        className={`v3-sadmin-page-btn ${b === page ? 'active' : ''}`}
                        onClick={() => onPageChange(b)}
                    >
                        {b}
                    </button>
                ))}
                <button
                    type="button"
                    className="v3-sadmin-page-btn"
                    onClick={() => onPageChange(page + 1)}
                    disabled={page >= pageCount}
                    aria-label={t('Next page')}
                >
                    <ChevronRight size={14} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
